import { Component } from '@angular/core';
import { Location } from '@angular/common';

import { Page } from '_interfaces/page';
import { PurchaseOrder } from 'models';
import { PurchaseOrderService } from '#services/api';
import { ToasterService } from '#services/shared';

@Component({
    selector: 'app-po-create',
    templateUrl: './po-create.component.html',
    styleUrls: ['./po-create.component.scss'],
  standalone: false
})
export class PoCreateComponent implements Page {
    // page
    pageTitle = 'Create material supply';
    pageDescription = 'fill data below to create new purchase order';

    // other properties
    purchaseOrder: PurchaseOrder = Object.assign(new PurchaseOrder(), { SubmitDate: new Date() });
    isValid = false;

    constructor(
        private purchaseOrderService: PurchaseOrderService,
        private location: Location,
        private toaster: ToasterService) {
    }

    isValidChanged(isValid: boolean) {
        this.isValid = isValid;
    }

    async onSubmit() {
        // The PO number field accepts one or more comma-separated values so that
        // several purchase orders can be created in a single submission. They all
        // share the same vendor, request number and submit date.
        const poNumbers = (this.purchaseOrder.PurchaseOrderNumber || '')
            .split(',')
            .map(n => n.trim())
            .filter(n => n.length > 0);

        if (poNumbers.length <= 1) {
            await this.purchaseOrderService.create(this.purchaseOrder).toPromise();

            this.location.back();
            this.toaster.showSuccess('Success...', 'Purchase order has been added.');
            return;
        }

        for (const poNumber of poNumbers) {
            const po = new PurchaseOrder();
            po.PurchaseOrderNumber = poNumber;
            po.RequestNumber = this.purchaseOrder.RequestNumber;
            po.SubmitDate = this.purchaseOrder.SubmitDate;
            po.FabricatorID = this.purchaseOrder.FabricatorID;
            po.Fabricator = this.purchaseOrder.Fabricator;

            await this.purchaseOrderService.create(po).toPromise();
        }

        this.location.back();
        this.toaster.showSuccess('Success...', `${poNumbers.length} purchase orders have been added.`);
    }

    onCancel() {
        this.location.back();
    }
}
